export default ({ fill = "#0E9F6E" }) => (
  <svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_59_13404)">
      <path
        d="M10 15.5H2C1.44687 15.5 1 15.0531 1 14.5V2.5C1 1.94687 1.44687 1.5 2 1.5H6V5C6 5.82812 6.67188 6.5 7.5 6.5H11V14.5C11 15.0531 10.5531 15.5 10 15.5ZM7.5 5.5C7.225 5.5 7 5.275 7 5V1.51562C7.0875 1.5375 7.16875 1.58125 7.23125 1.64688L10.8531 5.26875C10.9187 5.33438 10.9625 5.4125 10.9844 5.5H7.5ZM2 0.5C0.896875 0.5 0 1.39688 0 2.5V14.5C0 15.6031 0.896875 16.5 2 16.5H10C11.1031 16.5 12 15.6031 12 14.5V5.62187C12 5.225 11.8406 4.84375 11.5594 4.5625L7.94063 0.940625C7.65938 0.659375 7.27812 0.5 6.88125 0.5H2ZM3.5 8.5C3.225 8.5 3 8.725 3 9C3 9.275 3.225 9.5 3.5 9.5H8.5C8.775 9.5 9 9.275 9 9C9 8.725 8.775 8.5 8.5 8.5H3.5ZM3.5 10.5C3.225 10.5 3 10.725 3 11C3 11.275 3.225 11.5 3.5 11.5H8.5C8.775 11.5 9 11.275 9 11C9 10.725 8.775 10.5 8.5 10.5H3.5ZM3.5 12.5C3.225 12.5 3 12.725 3 13C3 13.275 3.225 13.5 3.5 13.5H8.5C8.775 13.5 9 13.275 9 13C9 12.725 8.775 12.5 8.5 12.5H3.5Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_59_13404">
        <rect width="12" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
